<ng-container *transloco="let t; read: 'SERVICE_SELECTION_MODAL'">
  <ion-toolbar>
    <div class="toolbar-header">
      <div class="left"></div>
      <h1>{{ t('TITLE') }}</h1>
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
  <div class="flex-column ion-padding content">
    <ng-container *ngIf="freeServices.length > 0">
      <div class="label mb-24 text-center">{{ t('CREATE_ORDER') }}</div>
      <ng-container *ngIf="!isOrderDailyLimitReached; else isOrderReachedTpl">
        <ion-button *ngFor="let s of freeServices" (click)="selectService(s)" fill="solid">
          {{ 'RestaurantServiceValues.' + s.service | transloco }}
        </ion-button>
      </ng-container>
      <ng-template #isOrderReachedTpl>
        <div class="warning-color text-center italic">{{ t('ORDER_DAILY_LIMIT_REACHED') }}</div>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="takenServices.length > 0">
      <div class="label mt-24 mb-24 text-center">{{ freeServices.length > 0 ? t('EDIT_ORDER_OR') : t('EDIT_ORDER') }}</div>
      <ion-button *ngFor="let s of takenServices" (click)="selectService(s)" fill="solid">
        {{ 'RestaurantServiceValues.' + s.service | transloco }}
      </ion-button>
    </ng-container>
  </div>
</ng-container>
